import { render, staticRenderFns } from "./DadosCidadeComplemento.vue?vue&type=template&id=1e6e14b7&"
import script from "./DadosCidadeComplemento.vue?vue&type=script&lang=ts&"
export * from "./DadosCidadeComplemento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
